import React, { useState, useCallback } from 'react';
import Cropper from 'react-easy-crop';
import { Dialog, DialogContent, DialogActions, Button, IconButton } from '@mui/material';
import * as PropTypes from 'prop-types';
import './index.css';
import CloseIcon from '@mui/icons-material/Close';

const ImageCropper = ({ open, onClose, image, onCropComplete, aspectRatio = 1 }) => {
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

    const handleCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);

    const handleApply = useCallback(() => {
        if (croppedAreaPixels) {
            onCropComplete(croppedAreaPixels);
        }
    }, [croppedAreaPixels, onCropComplete]);

    return (
        <Dialog
            fullWidth
            className="image_cropper_dialog"
            maxWidth="md"
            open={open}
            onClose={onClose}
        >
            <DialogContent className="cropper_content">
                <div className="header">
                    <p>Crop Thumbnail</p>
                    <IconButton aria-label="close" size="small" onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </div>
                <div className="cropper_container">
                    <Cropper
                        aspect={aspectRatio}
                        crop={crop}
                        image={image}
                        zoom={zoom}
                        onCropChange={setCrop}
                        onCropComplete={handleCropComplete}
                        onZoomChange={setZoom}
                    />
                </div>
            </DialogContent>
            <DialogActions>
                <Button
                    className="cancel_button"
                    onClick={onClose}
                >
                    Cancel
                </Button>
                <Button
                    className="crop_button"
                    disabled={!croppedAreaPixels}
                    onClick={handleApply}
                >
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
};

ImageCropper.propTypes = {
    image: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onCropComplete: PropTypes.func.isRequired,
    aspectRatio: PropTypes.number,
};

export default ImageCropper;
